import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Youtube, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import BrandLogo from './BrandLogo';
import { useSettings } from '../lib/settings';
import { dodDisclaimer } from '../data/dod8140Courses';

const SOCIAL_ICONS = [
  { key: 'socialFacebook', icon: Facebook },
  { key: 'socialTwitter', icon: Twitter },
  { key: 'socialLinkedin', icon: Linkedin },
  { key: 'socialYoutube', icon: Youtube },
  { key: 'socialInstagram', icon: Instagram },
];

export default function Footer() {
  const { settings } = useSettings();

  return (
    <footer className="bg-[#0f0d1a] text-gray-300 mt-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <BrandLogo size="lg" showWordmark={true} wordmarkClass="text-2xl" variant="dark" />
            </Link>
            <p className="text-sm text-gray-400 mb-5 leading-relaxed max-w-sm">
              {settings.footerAbout || 'Live online instructor-led certification training courses. Master the most in-demand skills with hands-on projects.'}
            </p>
            <div className="space-y-2 text-sm text-gray-400">
              {settings.contactPhone && <div className="flex items-center gap-2"><Phone size={14} className="text-[#ff5722]"/> {settings.contactPhone}</div>}
              {settings.contactEmail && <div className="flex items-center gap-2"><Mail size={14} className="text-[#ff5722]"/> {settings.contactEmail}</div>}
              {settings.contactAddress && <div className="flex items-center gap-2"><MapPin size={14} className="text-[#ff5722]"/> {settings.contactAddress}</div>}
            </div>
            <div className="flex items-center gap-3 mt-5">
              {SOCIAL_ICONS.map(({ key, icon: Icon }) => {
                const url = settings[key];
                if (!url || url === '#') return null;
                return (
                  <a key={key} href={url} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/5 hover:bg-gradient-to-br hover:from-[#6b47dc] hover:to-[#ff5722] grid place-items-center transition-all hover:scale-110">
                    <Icon size={16} />
                  </a>
                );
              })}
            </div>
          </div>

          {[
            { title: 'Categories', items: ['Data Science', 'Cloud Computing', 'DevOps', 'AI & ML', 'Cyber Security', 'Big Data'] },
            { title: 'Company', items: ['About Us', 'DoD 8140 Training', 'Careers', 'Reviews', 'Blog', 'Sitemap'] },
            { title: 'Support', items: ['Help Center', 'Contact Us', 'FAQs', 'Refund Policy', 'Privacy', 'Terms'] },
          ].map((col) => (
            <div key={col.title}>
              <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.items.map(item => (
                  <li key={item}>{item === 'DoD 8140 Training' ? <Link to="/dod-8140-certification-training" className="text-sm text-gray-400 hover:text-[#ff5722] transition-colors">DoD 8140 Training</Link> : <a href="#" className="text-sm text-gray-400 hover:text-[#ff5722] transition-colors">{item}</a>}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-xl border border-white/10 bg-white/5 p-4 text-xs text-gray-400 leading-relaxed">
          {dodDisclaimer}
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">{settings.footerCopyright || `© ${new Date().getFullYear()} Skillbridge.guru.`}</p>
          <div className="flex items-center gap-3 text-xs text-gray-400">
            <a href="#" className="hover:text-white">Privacy</a><span>•</span>
            <a href="#" className="hover:text-white">Terms</a><span>•</span>
            <a href="#" className="hover:text-white">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
